module.exports = __webpack_public_path__ + "static/reduce-stress-and-frustration-bd2958398b1d9a23cdd76c7e674de224.png";